import { ReactNode } from 'react';
import { To } from 'react-router-dom';
import Button from 'components/base/Button';
import { usePowerNavigate } from 'components/PowerNavigate';
import { isEmptyValue } from 'utils/helper';
import styles from './style.scss';

interface SummaryItemProps {
    title: string;
    detailList?: Array<{
        label: ReactNode;
        value: ReactNode;
    } | null>; // 资料详情
    errorMessage?: React.ReactNode;
    btnOptions: {
        text: string;
        type: 'modify' | 'view';
        navigatePath: To; // 点击跳转的地址，不传则无需跳转
    };
}

const SummaryItem: React.FC<SummaryItemProps> = ({ title, detailList, errorMessage, btnOptions }) => {
    const navigate = usePowerNavigate();
    const { text: btnText, type: btnType, navigatePath } = btnOptions || {};
    const handleClick = () => {
        if (navigatePath) {
            navigate(navigatePath);
        }
    };

    return (
        <section className={styles.root}>
            <div className={styles.header}>
                <div className={styles.title}>{title}</div>
                {btnOptions ? (
                    btnType === 'modify' ? (
                        <Button type="primary" size="sm" className={styles.btn} onClick={() => handleClick()}>
                            {btnText}
                        </Button>
                    ) : (
                        <Button type="dark" ghost size="sm" className={styles.btn} onClick={() => handleClick()}>
                            {btnText}
                        </Button>
                    )
                ) : null}
            </div>
            {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
            {!!detailList && (
                <ul className={styles.info}>
                    {detailList.map((item, index) => {
                        if (item) {
                            return (
                                <li className={styles.infoItem} key={index}>
                                    <span className={styles.itemLabel}>{item.label}</span>
                                    <span className={styles.itemValue}>
                                        {isEmptyValue(item.value) ? '--' : item.value}
                                    </span>
                                </li>
                            );
                        }

                        return null;
                    })}
                </ul>
            )}
        </section>
    );
};

export default SummaryItem;
